export default __webpack_public_path__ + "static/media/sCRO.67a176a0.svg";